import React from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { setCategory } from "./store/slices/dropdownSlice";
import "./Dropdown.css";

export default function Dropdown() {
  const dispatch = useDispatch();

  const handleCategoryChange = (categoryValue) => {
    dispatch(setCategory(categoryValue));
  };

  const categories = [
    { name: "Kashmiri Dry Fruits", image: "/thedata/kashmiridryfruits.webp" },
    { name: "Dry Fruits & Nuts", image: "/thedata/DryFriutsAndNuts.webp" },
    { name: "Honey & Saffron", image: "/thedata/KashmiriHoneyAndSaffron.webp" },
    { name: "Dates", image: "/thedata/Dates.webp" },
    { name: "Seeds", image: "/thedata/Seeds.webp" },
    { name: "Hamper Packages", image: "/thedata/WeddingHampers.webp" },
  ];

  return (
    <div className="dropdown-container">
      <h2 className="dropdown-title">Shop Our Range</h2>

      <div className="category-grid">
        {categories.map((category) => (
          <Link
            key={category.name}
            to="/category"
            className="category-item"
            onClick={() => handleCategoryChange(category.name)}
          >
            <img
              src={category.image}
              alt={category.name}
              className="category-image"
              loading="lazy"
              onLoad={(e) => e.target.classList.add("loaded")}
            />
            <span className="category-name">{category.name}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}